import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactGA from 'react-ga'

import Header from '../molecules/Header'
import { Content } from '../atoms/Content'
import { Typography, Button, Paper, withStyles } from '@material-ui/core'
import { navigate, Redirect } from '@reach/router'
import { bookingReset } from '../../store/booking/actions'
import { getBookingState } from '../../store/booking/selectors'
import { BookingReview } from '../molecules/BookingReview'
import { getAppPDV } from '../../store/app/selectors'
import { computeUrl } from '../atoms/BackButton'

const styles = theme => ({
  container: {
    padding: theme.spacing.unit * 4,
    textAlign: 'center'
  },
  button: { marginTop: theme.spacing.unit * 2 }
})

export class SuccessBase extends Component {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleClick = () => {
    const { onReset, pdvID } = this.props
    onReset()
    navigate(computeUrl('/', pdvID))
  }
  render() {
    const { classes, booking, pdvID } = this.props

    if (booking.services.length === 0) {
      return <Redirect to={computeUrl('/', pdvID)} noThrow />
    }
    return (
      <div>
        <Header />
        <Content>
          <Paper className={classes.container}>
            <div>
              <Typography variant="h4">Appuntamento fissato</Typography>
              <Typography variant="body2" gutterBottom>
                La prenotazione dell'appuntamento ha avuto successo
              </Typography>
              <BookingReview booking={booking} />
            </div>
            <Button
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={this.handleClick}
            >
              Prenota un altro appuntamento
            </Button>
          </Paper>
        </Content>
      </div>
    )
  }
}

export const Success = withStyles(styles)(SuccessBase)

const mapStateToProps = state => ({
  booking: getBookingState(state),
  pdvID: getAppPDV(state)
})
const mapDispatchToProps = dispatch => ({
  onReset: () => dispatch(bookingReset())
})

export const LinkedSuccess = connect(
  mapStateToProps,
  mapDispatchToProps
)(Success)
